import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { formatarData, formatarPlaca } from 'src/app/core/utils/utilities';
import {
  IGetRelatorioLaudosEditadosListParams,
  IGetRelatorioLaudosEditadosListResponse,
  IGetRelatorioLaudosEditadosItem
} from 'src/app/services/ReportService/report.model';
import { ReportService } from 'src/app/services/ReportService/report.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';

@Component({
  selector: 'app-laudos-editados',
  templateUrl: './laudos-editados.component.html',
  styleUrls: ['./laudos-editados.component.scss']
})
export class LaudosEditadosComponent {
  form = this.fb.group({
    TX_PLCA_CAVA: [null as string | null],
    DT_INIC: [null as string | null],
    DT_FIM: [null as string | null]
  });

  isLoading: boolean = false;
  numeroPagina: number = 0;
  maxPages: number = 1;
  tableData: Array<any> = [];

  pesquisaParams = {
    PAGE_NUMBER: 1,
    PAGE_SIZE: 20
  };

  tableColumns = [
    { header: 'Cód. Laudo', key: 'codigoLaudo', type: 'text' },
    { header: 'Placa', key: 'placa', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    { header: 'Criado em', key: 'criadoEm', type: 'text' },
    { header: 'Editado em', key: 'editadoEm', type: 'text' },
    { header: 'Editado por', key: 'editadoPor', type: 'text' }
  ];

  constructor(
    private fb: FormBuilder,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.pesquisaParams.PAGE_NUMBER = 1;
      this.numeroPagina = 0;
      this.loadData();
    });
  }

  mudarPagina(pagina: number): void {
    this.pesquisaParams.PAGE_NUMBER = pagina + 1;
    this.numeroPagina = pagina;
    this.loadData();
  }

  private createPayload(): IGetRelatorioLaudosEditadosListParams {
    return {
      TX_PLCA_CAVA: this.form.controls.TX_PLCA_CAVA.value ?? undefined,
      DT_INIC: this.form.controls.DT_INIC.value ?? undefined,
      DT_FIM: this.form.controls.DT_FIM.value ?? undefined,
      PAGE_NUMBER: this.pesquisaParams.PAGE_NUMBER,
      PAGE_SIZE: this.pesquisaParams.PAGE_SIZE
    };
  }

  loadData(): void {
    this.isLoading = true;
    const payload = this.createPayload();

    this.reportService.GetRelatorioLaudosEditados(payload).subscribe({
      next: (response: IGetRelatorioLaudosEditadosListResponse) => {
        this.tableData = response.ITEMS.map((item: IGetRelatorioLaudosEditadosItem) => ({
          codigoLaudo: item.PK_LAUD_SRVC ?? '---',
          placa: formatarPlaca(item.TX_PLCA_CAVA) ?? '---',
          motorista: item.NM_MTRT ?? '---',
          criadoEm: formatarData(item.DT_CRIA) ?? '---',
          editadoEm: formatarData(item.DT_ULTM_ATLZ ?? '') ?? '---',
          editadoPor: item.NM_FUNC_ULTM_ATLZ ?? '---'
        }));
        this.maxPages = response.TOTAL_PAGES;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  exportarExcel(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.reportService.GetReportLaudosEditadosExcel({
      TX_PLCA_CAVA: payload.TX_PLCA_CAVA,
      DT_INIC: payload.DT_INIC,
      DT_FIM: payload.DT_FIM
    }).subscribe({
      next: response => {
        this.appExportBase64.downloadExcel(response.ReportBase64, 'Laudos Editados.xlsx');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  exportarPDF(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.reportService.GetReportLaudosEditadosPdf({
      TX_PLCA_CAVA: payload.TX_PLCA_CAVA,
      DT_INIC: payload.DT_INIC,
      DT_FIM: payload.DT_FIM
    }).subscribe({
      next: response => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'Laudos Editados.pdf');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
